import React from 'react';
import { BasicDialog, CustomButton } from '..';
import { Box, Typography } from '@mui/material';

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  title: string;
  children: React.ReactNode;
  dialogProps?: Record<string, any>;
  showButton?: boolean;
}

export const ConsentTermsDialog: React.FC<IProps> = ({
  isOpen,
  handleClose,
  handleConfirm,
  title,
  children,
  dialogProps = {},
  showButton = true,
}) => {
  return (
    <BasicDialog isOpen={isOpen} handleClose={handleClose} {...dialogProps}>
      <Typography variant="h1">{title}</Typography>
      <Box
        component={'section'}
        py={4}
        sx={{
          '& .MuiTypography-body1': {
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", sans-serif',
            fontSize: '18px',
            fontWeight: 400,
            letterSpacing: 0,
          },
          '& .MuiTypography-h4': {
            marginTop: '48px',
          },
        }}
      >
        {children}
      </Box>
      {showButton && <CustomButton label="Close" onClick={handleConfirm} />}
    </BasicDialog>
  );
};

export default ConsentTermsDialog;
